import { RESET_STORE, STORE, WhitelistAction } from '../global';
import { checkWhitelist } from '../reducer-utils';
import { GET_POLICY_PDF_START, GET_POLICY_PDF_SUCCESS, GET_POLICY_PDF_FAILED, PolicyGetPdfStore } from './types';

const initialState = {
  loading: false,
  reqPolicyNumber: null,
  lang: null,
  error: null,
  result: {}
};

export const policyPdf = (
  state: PolicyGetPdfStore = {
    reqPolicyNumber: null,
    lang: null,
    loading: false,
    result: {}
  },
  action: {
    type: string;
    payload?: unknown;
    lang?: string;
  }
): PolicyGetPdfStore => {
  switch (action.type) {
    case GET_POLICY_PDF_START:
      return {
        loading: true,
        reqPolicyNumber: action.payload as string,
        lang: action.lang,
        result: state.result,
        error: null
      };
    case GET_POLICY_PDF_SUCCESS: {
      return {
        ...state,
        loading: false,
        result: {
          ...state.result,
          [`${state.reqPolicyNumber}_${state.lang}`]: action.payload as Blob
        }
      };
    }
    case GET_POLICY_PDF_FAILED: {
      return {
        ...state,
        loading: false,
        result: state.result,
        error: action.payload
      };
    }
    case RESET_STORE: {
      const { whitelist } = (action.payload ?? {}) as WhitelistAction;
      return checkWhitelist(whitelist, STORE.POLICY_GETPDF, state, initialState);
    }
    default:
      return state;
  }
};
